export const libraryHomepage = 'https://bibliotecaprahova.ro/';
export const libraryLogo = '/sigla-biblioteca-prahova-2026.png';

export default function InstitutionBrand() {
  return <a className="institution-brand" href={libraryHomepage} aria-label={'Biblioteca Județeană „Nicolae Iorga” Ploiești — site-ul oficial'}>
    <span className="institution-logo-frame"><img src={libraryLogo} width="158" height="153" alt="Sigla Bibliotecii Județene Nicolae Iorga"/></span>
    <span className="institution-title">
      <strong><span>Biblioteca Județeană</span><span>"Nicolae Iorga" Ploiești</span></strong>
      <small><span>Instituție publică de cultură</span><span>· din 1921</span></small>
    </span>
    <img className="institution-crest" src="/stema-prahova.png" width="231" height="254" alt="Stema județului Prahova"/>
  </a>;
}
